'use client';
import { Pagination } from 'antd';
import { __PaginationCompPropsType } from './pagination.type';

const PaginationComp = (Props: __PaginationCompPropsType) => {
    const { page, pageSize, total, onChange } = Props;

    return (
        <Pagination
            responsive
            current={page ?? 1}
            align="center"
            hideOnSinglePage
            total={total}
            pageSize={pageSize}
            onChange={onChange}
            className="mt-4"
        />
    );
};
export default PaginationComp;
